import FundReportService from "_fil_local_addon/camc-fund-report-list/fund_report_service";
const Paginator = require("./paginator");
class FundReportRender {
    constructor(root, category) {
        this.category = category;
        this.$root = $(root);
    }

    /**
     * Generates the HTML template for a report item.
     * @param {Object} item - The report item data.
     * @returns {string} - The HTML template for the report item.
     */
    generateTemplate(item) {
        const reportLink = item.report
            ? `<a href="${item.report}" target='_blank'>${item.title}</a>`
            : `<a href="#" target='_blank'>${item.title}</a>`;
        const displayDate = item.displayDate.slice(0, 10).split("-").join("/");
        return `
        <div class="cell small-12 medium-10 medium-centered card fil-report-list__card report-item">
            <div class="grid-x">
                <div class="report-img">
                    ${
                        item.category === "LEGAL"
                            ? `<img height="32px" width="32px" src="/static/camc_fund_report_list/pdf.svg">`
                            : `<img height="32px" width="32px" src="/static/camc_fund_report_list/news.svg">`
                    }
                </div>
                <div class="report-content">
                    <div class="report-content-wrapper">
                        <div class="report-title">${reportLink}</div>
                    </div>
                    <div class="report-date">${displayDate}</div>
                </div>
            </div>
        </div>`;
    }

    /**
     * Sets the total number of reports.
     * @param {number} num - The total number of reports.
     */
    setReportCount(num) {
        this.$root.find(".total-number strong").html(num);
    }

    errorhandler(err) {
        console.error(err);
    }

    async render() {
        try {
            const data = await FundReportService.getFundReport(window.fundCode, this.category);
            if (data?.length) {
                this.setReportCount(data.length);
                const $container = this.$root.find(".report-items");
                const fragment = data.map((item) => this.generateTemplate(item)).join("");
                $container.append(fragment);
            }
        } catch (err) {
            this.errorhandler(err);
        }
        this.$root.find(".search-results__spinner-container").hide();
        this.$root.find(".grid-container").removeClass("invisible");
        const paginator = new Paginator(this.$root, {
            disableSEO: true,
            disableURL: true,
        });
        paginator.rebuild();
    }
}

$(function () {
    $(".fil-fund-report-list").each(async function () {
        const category = $(this).attr("category");
        const fundReportRender = new FundReportRender(this, category);
        fundReportRender.render();
    });
});
